import { render, staticRenderFns } from "./LocationSupport.vue?vue&type=template&id=40a83f48"
import script from "./LocationSupport.vue?vue&type=script&lang=js"
export * from "./LocationSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports